<template>
    <b-container>
        <ValidationObserver ref="deviceRegisterForm" v-slot="{ invalid }">
            <b-form @submit.prevent="onSubmit">
                <validation-provider vid="customId" v-slot="{ errors }" rules="required|registeredDeviceIdLength"
                    :custom-messages="{ registeredDeviceIdLength: $t('device_register_id_invalid') }">
                    <b-form-group label-for="customId" :label="$t('device.register.customId')">
                        <b-input id="customId" v-model="device.customId" :disabled="saving" :placeholder="$t('device.register.customId')" />
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </validation-provider>
                <validation-provider vid="imei" v-slot="{ errors }" rules="required|digits:15">
                    <b-form-group label-for="imei" :label="$t('device.register.imei')">
                        <b-input id="imei" v-model="device.imei" :disabled="saving" :placeholder="$t('device.register.imei')" />
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </validation-provider>
                <div v-if="responseError" class="text-danger registration-error">{{$t('device_register_error')}}</div>
                <div v-if="created" class="registration-success">{{$t('device_register_created')}}</div>
                <div v-if="notFound" class="text-danger registration-not-found">{{$t('device_register_not_found')}}</div>
                <b-button :disabled="invalid || saving" type="submit" variant="primary">{{$t('device_register_submit')}}</b-button>
            </b-form>
        </ValidationObserver>
    </b-container>
</template>

<script>
    import axios from "axios";
    import { extend } from "vee-validate";
    import { getFieldErrors } from "../../utils/FormErrors";
    import { REQUEST_TIMEOUT_MS } from "../../utils/RequestGuard";

    const validCustomId = value => typeof value === 'string' && value.trim().length > 0 && Array.from(value).length <= 10;
    const validImei = value => typeof value === 'string' && /^[0-9]{15}$/.test(value);
    extend('registeredDeviceIdLength', { validate: value => typeof value === 'string' && Array.from(value).length >= 1 && Array.from(value).length <= 10 });

    export default {
        name: "DeviceRegister",
        data() {
            return {
                device: { customId: null, imei: null },
                created: false, notFound: false, responseError: false, saving: false,
                disposed: false, requestId: 0,
            };
        },
        beforeDestroy() { this.disposed = true; this.requestId++; },
        watch: {
            'device.customId'() { this.clearEditedFeedback(); },
            'device.imei'() { this.clearEditedFeedback(); },
        },
        methods: {
            clearEditedFeedback() {
                if (!this.saving) { this.created = false; this.notFound = false; this.responseError = false; }
            },
            async onSubmit() {
                if (this.disposed || this.saving) return;
                const observer = this.$refs.deviceRegisterForm;
                if (!observer || typeof observer.validate !== 'function') return;
                const request = ++this.requestId;
                const payload = { customId: this.device.customId, imei: this.device.imei };
                this.saving = true; this.created = false; this.notFound = false; this.responseError = false;
                observer.setErrors({});
                try {
                    const valid = await observer.validate();
                    if (this.disposed || request !== this.requestId || !valid) return;
                    const errors = {};
                    if (!validCustomId(payload.customId)) errors.customId = [this.$t('device_register_id_invalid')];
                    if (!validImei(payload.imei)) errors.imei = [this.$t('device_imei_invalid')];
                    if (Object.keys(errors).length) { observer.setErrors(errors); return; }
                    const response = await axios.post('api/v1/organisations/devices/register', payload, {
                        timeout: REQUEST_TIMEOUT_MS, headers: { 'Content-type': 'application/json' },
                    });
                    if (response.data !== 'ok') throw new Error('Registration was not accepted');
                    this.$store.commit('clearDeviceList');
                    if (this.disposed || request !== this.requestId) return;
                    this.created = true; this.$emit('onCreated', true);
                } catch (error) {
                    if (this.disposed || request !== this.requestId || error.response?.status === 401) return;
                    if (error.response?.status === 404) this.notFound = true;
                    else {
                        this.responseError = true;
                        if (error.response?.status === 400 && this.$refs.deviceRegisterForm) {
                            this.$refs.deviceRegisterForm.setErrors(getFieldErrors(error.response.data, ['customId', 'imei']));
                        }
                    }
                } finally {
                    if (!this.disposed && request === this.requestId) this.saving = false;
                }
            },
        },
    };
</script>

<style scoped>
</style>
